































































































































































import "@fullcalendar/core/vdom"; // solves problem with Vite
import FullCalendar from "@fullcalendar/vue";
import interactionPlugin, { Draggable } from "@fullcalendar/interaction";
import resourceTimelinePlugin from "@fullcalendar/resource-timeline";
import { Component, Vue } from "vue-property-decorator";
import AgendaPlanningItemPopup from "@/modules/agenda/popups/AgendaPlanningItemPopup.vue";
import AgendaPlanItemAdvancedPopup from "@/modules/agenda/popups/AgendaPlanItemAdvancedPopup.vue";
import DxTextBox from "devextreme-vue/text-box";
import DxCheckBox from "devextreme-vue/check-box";
import moment from "moment";
import { DxLoadPanel } from "devextreme-vue/load-panel";
import DxList from "devextreme-vue/list";
import dxCustomStore from "devextreme/data/custom_store";
import measuringStateForAgendaRepository from "../services/measuringStateForAgendaRepository";

import {
  GetPlanningAgendaItemsQuery,
  GetSinglePlanningAgendaItemForEditQuery,
  MeasuringStateForAgenda,
  MeasuringStatesClient,
  PlanningAgendaItem,
  PlanningsClient,
  QuotationForAgenda,
  QuotationListForAgendaQuery,
  QuotationsClient,
  TeamAgendaDto,
  TeamsClient,
  UpdatePlanningAgendaItemByDropCommand,
  UpdatePlanningAgendaItemCommand,
} from "@/data/web-api-client";
import DataSource from "devextreme/data/data_source";

@Component({
  components: {
    FullCalendar,
    AgendaPlanningItemPopup,
    AgendaPlanItemAdvancedPopup,
    DxTextBox,
    DxCheckBox,
    DxLoadPanel,
    DxList,
  },
})
export default class Agenda extends Vue {
  private projects: QuotationForAgenda[] = [];
  private measuringStates: MeasuringStateForAgenda[] = [];
  private clickFromAgenda: boolean = false;
  private teams: TeamAgendaDto[] = [];
  private searchValue: string = "";
  private allMeasuringStates: boolean = false;
  private loading: boolean = false;
  private viewStart: any;
  private viewEnd: any;
  private eventsLoaded: boolean = false;

  public mounted() {
    this.refresh();
  }

  data() {
    let self = this;
    return {
      calendarOptions: {
        schedulerLicenseKey: "CC-Attribution-NonCommercial-NoDerivatives",
        plugins: [interactionPlugin, resourceTimelinePlugin],
        height: window.innerHeight - 175,
        buttonText: {
          today: "Vandaag",
        },
        headerToolbar: {
          left: "",
          center: "title",
          right: "customToday prev,next",
        },
        customButtons: {
          customToday: {
            text: "Vandaag",
            click: function () {
              let calendar: any = self.$refs.fullCalendar;
              calendar.$options.calendar.gotoDate(
                moment().startOf("isoWeek").toDate()
              );
            },
          },
        },
        views: {
          planner: {
            type: "resourceTimelineWeek",
            buttonText: "Planner",
            slotDuration: "1.00:00:00",
            duration: { days: 7 },
          },
        },
        editable: true,
        initialView: "planner",
        firstDay: 0,
        weekends: true,
        locale: "nl",
        resourceAreaHeaderContent: "Teams",
        resourceAreaWidth: "15%",
        droppable: true,
        initialDate: moment().startOf("isoWeek").toDate(),
        eventReceive: this.drop,
        eventDrop: this.eventDrop,
        resources: this.getResources,
        events: this.getEvents,
        eventContent: this.eventRender,
        resourceLaneContent: this.recourceRender,
        eventClick: this.eventClick,
        dateClick: this.dateClick,
      },
    };
  }

  //#region Calendar Events

  private drop(dropEvent: any) {
    var planningItem = new PlanningAgendaItem();
    var originalObject: any;
    if (dropEvent.event.extendedProps.type == "MeasuringState") {
      originalObject = this.measuringStates.find(
        (x) => x.documentNumber == dropEvent.event.title
      );

      planningItem.measuringStateDocumentNumber = originalObject.documentNumber;
    } else {
      originalObject = null;
    }

    if (originalObject) {
      planningItem.id = "0";
      planningItem.teamId = dropEvent.event._def.resourceIds[0];
      planningItem.title = originalObject.documentNumber + ' - ' + originalObject.projectName;
      planningItem.projectId = originalObject.projectId;
      planningItem.subcontractorId = this.teams.find(
        (x) => x.id == planningItem.teamId
      )!.subcontractorId;
      planningItem.start = dropEvent.event.start;
    }
    dropEvent.revert();
    this.openPopup(planningItem);
    this.clickFromAgenda = false;
  }

  private async eventDrop(event: any) {
    if (
      window.confirm(
        "Planning item duurtijd zal herberekend worden volgens team."
      )
    ) {
      var client = new PlanningsClient(undefined, this.$axios);
      var planningItem = await client.getSingleAgendaItemForEdit(
        new GetSinglePlanningAgendaItemForEditQuery({
          id: event.event._def.publicId,
        })
      );
      planningItem.teamId = event.event._def.resourceIds[0];
      planningItem.start = event.event.start;
      planningItem.end = event.event.end;
      await client.updateAgendaItemByDrop(
        new UpdatePlanningAgendaItemByDropCommand({
          planningAgendaItem: planningItem,
          weekOfYear: event.event.extendedProps.weekOfYear,
        })
      );
      this.refetchEvents();
    } else {
      event.revert();
    }
  }

  private async getResources() {
    this.teams = await new TeamsClient(
      undefined,
      this.$axios
    ).getAllTeamsForAgenda();
    return this.teams;
  }

  private async getEvents(view: any) {
    this.getQuotations(view.start, view.end);
    this.viewStart = view.start;
    this.viewEnd = view.end;
    this.refreshMeasuringStates();

    var events = await new PlanningsClient(
      undefined,
      this.$axios
    ).getAgendaItems(
      new GetPlanningAgendaItemsQuery({ start: view.start, end: view.end })
    );

    events.forEach((x) => {
      x.end = moment(x.end).add(12, "hours").toDate();
    });

    this.eventsLoaded = true;
    return events;
  }

  private eventRender(event: any, element: any) {
    event.textColor = "black";
    event.borderColor = event.event._def.extendedProps.eventBackgroundColor;
    event.backgroundColor = event.event._def.extendedProps.eventBackgroundColor;
    event.timeText = "";
  }

  private recourceRender(resource: any) {}

  private async eventClick(event: any) {
    var planningItem = await new PlanningsClient(
      undefined,
      this.$axios
    ).getSingleAgendaItemForEdit(
      new GetSinglePlanningAgendaItemForEditQuery({
        id: event.event._def.publicId,
      })
    );
    this.openPopup(planningItem);
  }

  private async dateClick(resource: any) {
    this.clickFromAgenda = true;
    var planningItem = new PlanningAgendaItem();
    planningItem.id = "0";
    planningItem.start = resource.date;
    this.openPopup(planningItem);
  }

  //#endregion

  //#region Api Methods

  private async getQuotations(start: any = null, end: any = null) {
    this.loading = true;
    let calendar: any = this.$refs.fullCalendar;
    if (calendar.getApi() != undefined) {
      let view = calendar.getApi().view;
      var viewStart = view.activeStart;
      var viewEnd = view.activeEnd;

      var result = await new QuotationsClient(
        undefined,
        this.$axios
      ).getQuotationsForAgenda(
        new QuotationListForAgendaQuery({
          start: start != null ? start : viewStart,
          end: end != null ? end : viewEnd,
        })
      );
      this.projects = result;
      this.loading = false;
    }
  }

  //#endregion

  //#region Popups

  private openPopup(planningItem: PlanningAgendaItem) {
    (this.$refs.AgendaPlanningItemPopup as AgendaPlanningItemPopup).Open(
      planningItem,
      this.clickFromAgenda
    );
  }

  private openPlanAdvancedPopup(
    planningItem: PlanningAgendaItem,
    startDateProject: Date
  ) {
    (
      this.$refs.AgendaPlanItemAdvancedPopup as AgendaPlanItemAdvancedPopup
    ).Open(planningItem, startDateProject);
  }

  //#endregion

  //#region Navigation Methods

  private navigateToProject(projectId: string) {
    // this.loading = true;
    var routeData = this.$router.resolve({ path: `/projects/${projectId}` });
    window.open(routeData.href, "_blank");
  }

  private navigateToQuotation(projectId: string) {
    // this.loading = true;
    var routeData = this.$router.resolve({
      path: `/projects/${projectId}?navIndex=1&sideNavIndex=0`,
    });
    window.open(routeData.href, "_blank");
  }

  private navigateToMeasuringState(documentNumber: string) {
    // this.loading = true;
    documentNumber = documentNumber.replaceAll("/", "-");
    var routeData = this.$router.resolve({
      path: `/measuringstates/${documentNumber}`,
    });
    window.open(routeData.href, "_blank");
  }

  //#endregion

  //#region Change Events

  private searchValueChanged(event: any) {
    if (event.value != event.previousValue) {
      this.searchValue = event.value;
      this.refreshMeasuringStates();
    }
  }

  private measuringStatesIncludeChanged(event: any) {
    this.allMeasuringStates = event.value;
    this.refreshMeasuringStates();
  }

  //#endregion

  public setupDraggable() {
    const t = document.getElementById("measuringStateList")!;
    if (t) {
      new Draggable(document.getElementById("measuringStateList")!, {
        itemSelector: ".measuringStateStyle",
        eventData: function (eventEl) {
          let event = {
            title: eventEl.getElementsByClassName("span")[0].innerHTML.trim(),
            duration: "08:00",
            type: "MeasuringState",
          };
          return event;
        },
      });
    }
  }

  private refresh() {
    this.getQuotations();
    this.refreshMeasuringStates();
    this.setupDraggable();
    this.refetchEvents();
  }

  private refetchEvents() {
    let calendar: any = this.$refs.fullCalendar;
    calendar.getApi().refetchEvents();
  }

  private planItem(measuringState: MeasuringStateForAgenda) {
    var planningItem = new PlanningAgendaItem();
    planningItem.title = measuringState.documentNumber + ' - ' + measuringState.projectName;
    planningItem.measuringStateDocumentNumber = measuringState.documentNumber;
    planningItem.end = undefined;
    planningItem.workTypes = [];
    if (measuringState.workType) {
      planningItem.workTypes.push(measuringState.workType);
    }
    planningItem.projectId = measuringState.projectId;
    planningItem.tasks = [];
    planningItem.members = [];
    planningItem.subcontractorId = measuringState.subcontractorId;
    planningItem.projectId = measuringState.projectId;
    this.openPlanAdvancedPopup(planningItem, measuringState.startDateProject!);
  }

  public refreshMeasuringStates() {
    let list: any = this.$refs.measuringStateDxList;
    if (list) {
      list.instance.reload();
    }
  }

  get measuringStateDatasource() {
    const self = this;
    return new DataSource({
      store: new dxCustomStore({
        key: "id",
        load: async (loadOptions) => {
          const result = await measuringStateForAgendaRepository.lookup(
            loadOptions,
            self.viewStart,
            self.viewEnd,
            self.allMeasuringStates,
            self.searchValue
          );
          setTimeout(() => {
            self.setupDraggable();
          }, 200);
          self.measuringStates = result.data.data;
          return result.data;
        },
      }),
      paginate: true,
      pageSize: 20,
    });
  }
}
